import { useKeyboardShortcut } from './useKeyboardShortcut';

/**
 * 三态按键声明：
 * - `() => void`：注册 handler，按键命中时执行，同时阻断向下层传递
 * - `false`：不注册 handler，但阻断按键向下层传递（显式声明"当前层不处理，也不允许下层处理"）
 * - `undefined`：不注册、不阻断，按键可继续向下层传递
 */
type KeyboardHandler = (() => void) | false;

/** 业务通过壳组件 keyboard prop 传入的快捷键配置 */
export interface DialogKeyboardConfig {
  onEnter?: KeyboardHandler;
  onEscape?: KeyboardHandler;
  allowEnterInInput?: boolean;
}

export interface UseDialogKeyboardOptions {
  onEnter?: KeyboardHandler;
  onEscape?: KeyboardHandler;
  allowEnterInInput?: boolean;
  enabled?: boolean;
}

/**
 * 壳组件专用的键盘快捷键 hook，基于 useKeyboardShortcut 封装。
 *
 * 与 useKeyboardShortcut 的区别：支持 `false` 显式阻断语义，
 * 壳组件通过 `??` 将业务传入的 keyboard 配置与自身默认行为合并后传入。
 */
export function useDialogKeyboard({
  onEnter,
  onEscape,
  allowEnterInInput = false,
  enabled = true,
}: UseDialogKeyboardOptions): void {
  useKeyboardShortcut({
    onEnter: onEnter || undefined,
    onEscape: onEscape || undefined,
    allowEnterInInput,
    blockEnter: enabled && onEnter === false,
    blockEscape: enabled && onEscape === false,
    enabled,
  });
}
